import { IApplicationState } from '@store'

export const selectIsTransferringMedia = (state: IApplicationState) =>
  state.facebookAds.isTransferringMedia
